import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_svg = _resolveComponent("icon-svg")!

  return (_openBlock(), _createElementBlock("button", {
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.handleKeyDown && $options.handleKeyDown(...args))),
    class: _normalizeClass([`variant-${$props.variant}`, "icon-btn"]),
    style: {"border":"1px solid var(--active-color)","--hover-color":"color-mix(in srgb, currentColor 5%, white)","--active-color":"color-mix(in srgb, currentColor 22%, white)"}
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_icon_svg, { name: $props.name }, null, 8, ["name"])
    ])
  ], 34))
}